// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list-item[data-v-0c17bb5e]{min-height:28px!important}.v-list-item--dense .v-list-item__content[data-v-0c17bb5e]{padding:0}.v-application .v-menu__content[role=menu] .v-list-item[data-v-0c17bb5e]:first-child{border-top:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
